export const paymentTypes = [
  { value: 'TRIAL' },
  { value: 'SINGLE_PURCHASE' },
  { value: 'PREPAID' },
  { value: 'PREPAID_SAAS' },
  { value: 'POSTPAID' },
  { value: 'POSTPAID_SAAS' },
  { value: 'SUBSCRIPTION_TRIMESTER' },
  { value: 'SUBSCRIPTION_SEMESTER' },
  { value: 'SUBSCRIPTION_NONAMESTER' },
  { value: 'SUBSCRIPTION_YEAR' },
  { value: 'SUBSCRIPTION_LIFELONG' },
]

export const conditionals = [{ value: true }, { value: false }]
